import { useQuery } from "@tanstack/react-query";
import { oauth2Service } from "@/lib/oauth2";

export function useOAuth2Providers() {
  return useQuery({
    queryKey: ["oauth2", "providers"],
    queryFn: async () => {
      const providers = await oauth2Service.getProviders();
      return providers.filter((p) => p.enabled);
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
